module.exports = __webpack_public_path__ + "img/al.bf311baf.svg";